import React from 'react';
import { services } from '../mock';
import { AddOns } from '../components/AddOns';
import { Button } from '../components/ui/button';
import { ArrowRight, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ServicesPage() {
  const navigate = useNavigate();

  return (
    <div className="pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#0B7CB5]/10 to-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Our <span className="text-[#0B7CB5]">Cleaning Services</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Professional cleaning solutions tailored to your needs — from standard maintenance to specialized services
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate('/calculator')}
              size="lg"
              className="bg-[#0B7CB5] hover:bg-[#095a87] text-white px-8 py-6 text-lg"
            >
              Get Instant Estimate
            </Button>
            <a 
              href="tel:+18045837000"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors h-10 border-2 border-[#0B7CB5] text-[#0B7CB5] hover:bg-[#0B7CB5] hover:text-white px-8 py-6 text-lg"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 50 }}
            >
              <Phone className="mr-2 w-5 h-5" />
              Call or Text (804) 583-7000
            </a>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {services.map((service) => {
              // Commercial and Hazardous services should go to contact form on calculator page
              const isContactService = service.id === 4 || service.id === 6;
              
              return (
                <div
                  key={service.id}
                  id={service.title.toLowerCase().replace(/\s+/g, '-').replace(/\//g, '-').replace(/&/g, '')}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 scroll-mt-24"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <h3 className="absolute bottom-4 left-6 text-3xl font-bold text-white">
                      {service.title}
                    </h3>
                  </div>
                  <div className="p-6">
                    <p className="text-gray-700 leading-relaxed mb-4 text-lg">{service.description}</p>
                    <Button
                      onClick={() => navigate(isContactService ? '/calculator#contact-form' : '/calculator')}
                      className="bg-[#0B7CB5] hover:bg-[#095a87] text-white w-full group"
                    >
                      {isContactService ? 'Get a Custom Quote' : 'Calculate Price'}
                      <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Add-Ons Section */}
      <AddOns />

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-b from-white to-[#0B7CB5]/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Contact us today for a free consultation and experience the Custom Maids RVA difference
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:+18045837000"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors h-10 bg-[#0B7CB5] hover:bg-[#095a87] text-white px-8 py-6 text-lg"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 50 }}
            >
              <Phone className="mr-2 w-5 h-5" />
              Call or Text: (804) 583-7000
            </a>
            <a 
              href="mailto:custommaidsrva@gmail.com"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors h-10 border-2 border-[#0B7CB5] text-[#0B7CB5] hover:bg-[#0B7CB5] hover:text-white px-8 py-6 text-lg"
              style={{ touchAction: 'manipulation', cursor: 'pointer', WebkitTapHighlightColor: 'rgba(11, 124, 181, 0.3)', zIndex: 50 }}
            >
              Email Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
